import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"
import { cn } from "@/lib/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    timeProgress?: number;
  }
>(({ className, value, timeProgress, ...props }, ref) => (
  <div className="space-y-2">
    {/* Goal Progress Bar */}
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-3 w-full overflow-hidden rounded-full bg-white/20 dark:bg-gray-800",
        className
      )}
      {...props}
    >
      <div
        className="h-full bg-[#FFCE04] transition-all"
        style={{ width: `${value || 0}%` }}
      />
    </ProgressPrimitive.Root>

    {/* Time Progress Bar */}
    <ProgressPrimitive.Root
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-white/20 dark:bg-gray-800",
      )}
    >
      <div
        className="h-full bg-[#FF3366] transition-all"
        style={{ width: `${timeProgress || 0}%` }}
      />
    </ProgressPrimitive.Root>
  </div>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }